import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_header",
  class: "header w-100",
  "data-kt-sticky": "true",
  "data-kt-sticky-name": "header",
  "data-kt-sticky-offset": "{default: '300px', lg: '300px'}"
}
const _hoisted_2 = {
  class: "w-100",
  id: "kt_header_container"
}
const _hoisted_3 = { class: "mt-5 d-flex h-100" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = ["alt"]
const _hoisted_6 = { class: "d-flex ms-3 me-5" }
const _hoisted_7 = { class: "d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 text-center" }, null, -1)
const _hoisted_9 = { class: "d-flex flex-center flex-column flex-column-fluid" }
const _hoisted_10 = { class: "text-center mt-10" }
const _hoisted_11 = { class: "d-flex flex-center flex-column-auto pt-5" }
const _hoisted_12 = { class: "d-flex align-items-center fw-bold fs-6" }
const _hoisted_13 = { class: "d-none d-md-block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_language_switcher = _resolveComponent("language-switcher")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTFooter = _resolveComponent("KTFooter")!
  const _component_MobileFooter = _resolveComponent("MobileFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("img", {
            id: "iii-plus-logo-header-login",
            src: "/media/logos/head_logo.png",
            class: "px-10 d-none d-md-block",
            alt: _ctx.translate('III_PLUS_LOGO')
          }, null, 8, _hoisted_4),
          _createElementVNode("img", {
            src: "/media/logos/logo.png",
            class: "h-50px px-10 d-block d-md-none",
            alt: _ctx.translate('III_PLUS_COMPACTED_LOGO')
          }, null, 8, _hoisted_5),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_language_switcher)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_router_view)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_inline_svg, {
          class: "h-50px",
          src: "/media/vectorial/valored_logo.svg",
          alt: _ctx.translate('VALORED_PROJECT_LOGO'),
          title: _ctx.translate('VALORED_PROJECT_LOGO'),
          "aria-label": _ctx.translate('VALORED_PROJECT_LOGO')
        }, null, 8, ["alt", "title", "aria-label"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_KTFooter)
          ]),
          _createVNode(_component_MobileFooter)
        ])
      ])
    ])
  ], 64))
}